import {
  getSearchRecurring,
  RecurringFileList,
  SearchRecurringResponse,
  SuccessResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* SearchRecurringRequest(
  self: Self,
  query: string
): Generator<Promise<FlowReturn<SearchRecurringResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getSearchRecurring(query);
    const { data, status } = (response as SearchRecurringResponse).data;
    self.recurringFile.reset();
    if (data?.RecurringFile) {
      const modifiedData = mapStatus(data.RecurringFile);
      self.recurringFile.list = cast(modifiedData);
      self.recurringFile.pagination = data?.PaginationInfo;
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status?.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

const mapStatus = (data: RecurringFileList[]): RecurringFileList[] =>
  data.map((item) => {
    if (item.status === 'Ongoing processing') {
      if (item.process_status === 'Ready') {
        item.status = 'In queue';
      } else if (item.process_status === 'Processing') {
        item.status = 'Ongoing processing';
      }
    }
    return item;
  });

export default SearchRecurringRequest;
